import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Empty, Spin, Alert } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { FileItem } from "./FileItem";
import { FileUpload } from "./FileUpload";
import { getArchivosSolicitud } from "../../../../context/actions/solicitudesActions";

export const FilesList = ({ solicitud }) => {
  const dispatch = useDispatch();
  const { archivosActuales, loadingArchivos } = useSelector(
    state => state.solicitudesReducer
  );

  useEffect(() => {
    if (solicitud?.proveedorSolicitudID) {
      dispatch(getArchivosSolicitud(solicitud.proveedorSolicitudID));
    }
  }, [solicitud?.proveedorSolicitudID, dispatch]);

  // Re-renderizar cuando archivosActuales cambie (por ejemplo, cuando se recarga)
  useEffect(() => {
    // Este efecto solo existe para forzar re-render cuando cambian los archivos
  }, [archivosActuales]);

  const esSolicitudCerrada = solicitud?.estatus === "Cerrado";

  // Ordenar archivos por fecha (más reciente primero)
  const archivosOrdenados = [...archivosActuales].sort((a, b) => 
    new Date(b.fechaCarga) - new Date(a.fechaCarga)
  );

  if (loadingArchivos) {
    return (
      <div className="files-loading">
        <Spin size="large" />
        <p style={{ marginTop: 16, textAlign: 'center', color: '#666' }}>
          Cargando archivos...
        </p>
      </div>
    );
  }

  return (
    <div className={`files-container ${esSolicitudCerrada ? 'solicitud-cerrada' : ''}`}>
      {/* Upload area - solo si no está cerrada */}
      {!esSolicitudCerrada && (
        <div className="files-upload-section">
          <FileUpload solicitudId={solicitud?.proveedorSolicitudID} />
        </div>
      )}

      {/* Lista de archivos */}
      <div className="files-list-section">
        {archivosOrdenados.length > 0 ? (
          <>
            <div className="files-header">
              <span className="files-header-text">
                Archivos compartidos ({archivosOrdenados.length})
              </span>
            </div>
            
            <div className="files-list">
              {archivosOrdenados.map((archivo) => (
                <FileItem 
                  key={archivo.proveedorSolicitudDocumentoID} 
                  archivo={archivo} 
                />
              ))}
            </div>
          </>
        ) : (
          <Empty
            image={<FileTextOutlined style={{ fontSize: '48px', color: '#ccc' }} />}
            description={
              <div>
                <p style={{ margin: '8px 0 4px', color: '#666' }}>No hay archivos en esta solicitud</p>
                {!esSolicitudCerrada && (
                  <p style={{ margin: 0, fontSize: '12px', color: '#999' }}>
                    Sube el primer archivo para compartir documentos
                  </p>
                )}
              </div>
            }
          />
        )}
      </div>

      {/* Mensaje informativo para solicitudes cerradas */}
      {esSolicitudCerrada && archivosOrdenados.length > 0 && (
        <Alert
          message="Solicitud cerrada"
          description="Esta solicitud está cerrada. Solo puedes descargar archivos existentes."
          type="info"
          showIcon
          style={{ marginTop: 16 }}
        />
      )}

      <style jsx>{`
        .files-container {
          padding: 0;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }
        
        .files-loading {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 300px;
        }
        
        .files-upload-section {
          flex-shrink: 0;
          margin-bottom: 8px;
        }
        
        .files-list-section {
          flex: 1;
          min-height: 0;
          display: flex;
          flex-direction: column;
        }
        
        .files-header {
          margin-bottom: 12px;
          padding-bottom: 8px;
          border-bottom: 1px solid #f0f0f0;
          flex-shrink: 0;
        }
        
        .files-header-text {
          font-size: 13px;
          color: #666;
          font-weight: 500;
        }
        
        .files-list {
          overflow-y: auto;
          overflow-x: hidden;
          flex: 1;
          min-height: 0;
          padding-right: 8px;
          padding-bottom: 8px;
        }
        
        .files-list::-webkit-scrollbar {
          width: 8px;
        }
        
        .files-list::-webkit-scrollbar-track {
          background: #f5f5f5;
          border-radius: 4px;
          margin: 2px;
        }
        
        .files-list::-webkit-scrollbar-thumb {
          background: #d9d9d9;
          border-radius: 4px;
          border: 1px solid #f5f5f5;
        }
        
        .files-list::-webkit-scrollbar-thumb:hover {
          background: #bfbfbf;
        }
        
        /* Firefox scrollbar */
        .files-list {
          scrollbar-width: thin;
          scrollbar-color: #d9d9d9 #f5f5f5;
        }
        
        .ant-empty {
          margin: 50px 0;
        }
        
        .ant-empty-description {
          color: #999;
        }
      `}</style>
    </div>
  );
};